import { apiClient } from './apiClient';

export type GtmAnalyticsSummary = {
  totalProspects: number;
  totalOpportunities: number;
  wonOpportunities: number;
  wonRevenue: number;
  pipelineValue: number;
  prospectToOpportunityRate: number;
  opportunityWinRate: number;
};

export type GtmProductMetric = {
  salesProductId?: string | null;
  name: string;
  prospectCount: number;
  opportunityCount: number;
  wonCount: number;
  wonRevenue: number;
  pipelineValue: number;
  estimatedLtv: number;
};

export type GtmMarketSegmentMetric = {
  marketSegmentId: string;
  name: string;
  opportunityCount: number;
  wonCount: number;
  wonRevenue: number;
  pipelineValue: number;
};

export type GtmCampaignMetric = {
  campaignTag: string;
  prospectCount: number;
  opportunityCount: number;
  wonRevenue: number;
};

export type GtmBuyerPersonaMetric = {
  buyerPersonaId: string;
  name: string;
  prospectCount: number;
  opportunityCount: number;
};

export type GtmAnalytics = {
  summary: GtmAnalyticsSummary;
  byProduct: GtmProductMetric[];
  byMarketSegment: GtmMarketSegmentMetric[];
  byCampaign: GtmCampaignMetric[];
  byBuyerPersona: GtmBuyerPersonaMetric[];
  generatedAtUtc: string;
};

export async function fetchGtmAnalytics(): Promise<GtmAnalytics> {
  const response = await apiClient.get<GtmAnalytics>('/v1/sales/gtm-analytics');
  return response.data;
}
